import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
interface CarcinogenicModuleFooterProps {
    handleCancelClick: any;
    handleSubmitClick: any;
    lastPage?: boolean;
    disableCancelButton?: boolean;
    disableNextButton?: boolean;
    onlyVisual?: boolean;
}

const CarcinogenicModuleFooter = ({
    handleCancelClick,
    handleSubmitClick,
    lastPage = false,
    disableCancelButton = false,
    disableNextButton = false,
    onlyVisual = false
}: CarcinogenicModuleFooterProps) => {
    const { t } = useTranslation('carcinogenicReport');
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
            <Button
                variant="outlined"
                onClick={handleCancelClick}
                sx={{ mr: 1 }}
                disabled={disableCancelButton}
                data-testid={!onlyVisual ? 'footer.buttons.cancel' : 'footer.buttons.previous'}
            >
                {!onlyVisual ? t('footer.buttons.cancel'): t('footer.buttons.previous')}
            </Button>
            <Button
                variant="contained"
                color="primary"
                onClick={handleSubmitClick}
                disabled={disableNextButton}
                data-testid={'footer.buttons.next'}
            >
                {lastPage && !onlyVisual
                    ? t('footer.buttons.sendReport')
                    : t('footer.buttons.next')}
            </Button>
        </Box>
    );
};

export {CarcinogenicModuleFooter}
